import "../../styles/atoms.scss";
import { useState, useEffect, useRef } from "react";
import countriesData from "../../data/countries.json";
import CountryFlag from "../../data/IconCountry";
import SvgIcn from "../../data/IconCompo";

const CountryDropDown = ({
  iconRHover,
  iconR,
  iconL,
  focusL,
  placeholder,
  className = "",
  onSelect,
  value = "",
  name,
  error,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [inputValue, setInputValue] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const dropdownRef = useRef(null);
  const inputRef = useRef(null);
  const optionRefs = useRef([]);

  const options = countriesData.map((country) => ({
    label: country.label,
    iso2: country.iso2,
    value: country.value,
  }));



  useEffect(() => {
    if (value !== selectedOption?.value) {
      const valueOption = countriesData.find((option) => option.value === value);
      setSelectedOption(valueOption);
      setInputValue(valueOption?.label);
    }
  }, [value]);

  const handleInputChange = (e) => {
    const newValue = e?.target?.value;

    setInputValue(newValue);

    const filtered = options.filter((option) =>
      option.label.toLowerCase().includes(newValue.toLowerCase())
    );
    setFilteredOptions(filtered);
    setIsDropdownOpen(filtered.length > 0);

    onSelect?.({ value: null, name });
    setHighlightedIndex(-1);
  };

  const handleOptionClick = (option) => {
    onSelect?.({ value: option.value, name });
    setSelectedOption(option);
    setInputValue(option.label);
    setFilteredOptions([]);
    setIsDropdownOpen(false);
    setIsFocused(false);
  };

  const handleFocus = () => {
    setIsFocused(true);
    setFilteredOptions(options);
    const filtered = options.filter((option) =>
      option.label.toLowerCase().includes(inputValue?.toLowerCase())
    );
    if(inputValue){
      setFilteredOptions(filtered);
    }else{
      setFilteredOptions(options);
    }
    setIsDropdownOpen(true);
  };

  const handleKeyDown = (e) => {
    if (
      e.key === "ArrowDown" &&
      highlightedIndex < filteredOptions.length - 1
    ) {
      setHighlightedIndex((prevIndex) => {
        const newIndex = prevIndex + 1;
        scrollToHighlightedOption(newIndex);
        return newIndex;
      });
    } else if (e.key === "ArrowUp" && highlightedIndex > 0) {
      setHighlightedIndex((prevIndex) => {
        const newIndex = prevIndex - 1;
        scrollToHighlightedOption(newIndex);
        return newIndex;
      });
    } else if (e.key === "Enter" && highlightedIndex >= 0) {
      handleOptionClick(filteredOptions[highlightedIndex]);
    } else if (e.key === "Escape") {
      setIsDropdownOpen(false);
    }
  };

  const scrollToHighlightedOption = (index) => {
    if (optionRefs.current[index]) {
      optionRefs.current[index].scrollIntoView({
        block: "nearest",
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !dropdownRef.current?.contains(event.target) &&
        !inputRef.current?.contains(event.target)
      ) {
        setIsDropdownOpen(false);
        setIsFocused(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleClear = () => {
    setInputValue("");
    setSelectedOption(null);
    setFilteredOptions([]);
    setIsDropdownOpen(false);
    onSelect?.({ value: "", name });
  };

  return (
    <div
      className={`input-icon-box ${isFocused ? "focused" : ""} ${className} ${
        error ? "input-error" : ""
      }`}
    >
      <div className="input-container">
        {selectedOption ? (
          <CountryFlag
            Name={selectedOption.iso2.toLowerCase()}
            className="flag-icon-in-input"
          />
        ) : (
          <h5>
            <SvgIcn name={iconL} />
          </h5>
        )}

        <input
          type="text"
          className={`input ${isFocused ? "focused-input" : ""}`}
          placeholder={placeholder}
          value={inputValue}
          onFocus={handleFocus}
          onBlur={() => {
            setTimeout(() => {
              setIsFocused(false);
              if (!value) setSelectedOption(null);
            }, 200);
          }}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          ref={inputRef}
        />

        <span className="icon right-icon">
          {inputValue ? (
            <SvgIcn name="clear" onClick={handleClear} />
          ) : (
            <SvgIcn
              name={isDropdownOpen ? iconRHover : iconR}
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            />
          )}
        </span>
      </div>

      {isDropdownOpen && filteredOptions.length > 0 && (
        <div className="dropdown" ref={dropdownRef}>
          <div className="dropdown-scroll">
            {filteredOptions.map((option, index) => (
              <div
                key={index}
                ref={(el) => (optionRefs.current[index] = el)}
                className={`dropdown-option ${
                  index === highlightedIndex ? "highlighted" : ""
                }`}
                onMouseDown={(e) => {
                  e.preventDefault();
                  handleOptionClick(option);
                }}
                style={{ color: index === highlightedIndex ? "blue" : "black" }}
              >
                <CountryFlag Name={option.iso2.toLowerCase()} />
                {option.label}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CountryDropDown;
